module.exports = __webpack_public_path__ + "static/media/indicators-icon.3c81f82f.svg";